import React from "react";
import { DateFieldComponent } from "../../DatePicker";

interface Props {
  control: any;
  register: any;
  errors: any;
  onStartDateChange: (date: number) => void;
  onEndDateChange: (date: number) => void;
}

function AssignationEditionFields({ control, register, errors, onStartDateChange, onEndDateChange }: Props) {
  return (
    <>
      <DateFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"shortStartDate"}
        label="Start Date"
        required={true}
        clearable={false}
        onChange={onStartDateChange}
        toUTC
      />

      <DateFieldComponent
        control={control}
        register={register}
        errors={errors}
        propertyName={"shortEndDate"}
        label="End Date"
        required={false}
        clearable={true}
        onChange={onEndDateChange}
        toUTC
      />
    </>
  );
}

export default AssignationEditionFields;
